import colors from "common/styles/colors";

export const sharersDialogStyles = {
  dialogTitleContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    fontSize: 22,
    fontWeight: 600,
    pb: 1
  },

  link: {
    textDecoration: "none",
    color: colors.primary,
    fontSize: 14,
    fontWeight: 600,
    cursor: "pointer"
  },

  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: 120
  },

  noSharersMessage: {
    mt: 2,
    fontWeight: 400
  },

  subtitle: {
    mb: 2
  },

  closeButton: {
    minWidth: 90,
    textTransform: "none",
    fontWeight: 600,
    fontSize: 14
  },

  dialogActions: {
    pr: 3,
    pb: 4
  }
};
